import Spinner from '@jgile/laravel-vue/resources/js/components/Spinner';

import {
    BOverlay,
    BTooltip,
    CardPlugin,
    DropdownPlugin,
    FormCheckboxPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormPlugin,
    FormRadioPlugin,
    FormSelectPlugin,
    FormTextareaPlugin,
    InputGroupPlugin,
    ListGroupPlugin,
    ModalPlugin,
    PaginationPlugin,
    PopoverPlugin,
    TabsPlugin,
    VBToggle,
    VBTooltipPlugin,
} from 'bootstrap-vue';

Vue.component('b-overlay', {
    mixins: [BOverlay],
    props: {
        variant: {
            type: String,
            default: 'white',
        },
    },
    methods: {
        defaultOverlayFn({ spinnerType, spinnerVariant, spinnerSmall }) {
            return this.$createElement(Spinner);
        },
    },
});

Vue.component('b-tooltip', BTooltip);
Vue.use(PopoverPlugin);
Vue.use(CardPlugin);
Vue.use(FormPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(InputGroupPlugin);
Vue.use(PaginationPlugin);
Vue.use(TabsPlugin);
Vue.use(ModalPlugin);
Vue.use(ListGroupPlugin);
Vue.use(DropdownPlugin);
Vue.use(VBTooltipPlugin);
Vue.directive('b-toggle', VBToggle);
